<template>
  <div class="not-found">
    <vb-icon v-if="icon" class="not-found__icon" :name="icon" :color="sass('primary')" :size="100" />
    <span class="not-found__title" v-html="text.title" />
    <span class="not-found__message" v-html="text.message" />
    <span class="not-found__suggestion" v-html="text.suggestion" />
    <slot name="default"></slot>
  </div>
</template>

<script>

export default {
  name: 'not-found',

  components: {
  },

  props: {
    icon: {
      type: String,
      default: 'face_thinking'
    },
    text: {
      type: Object,
      default: () => {
        return {
          title: `<strong>Oops!</strong><br> Qualcosa non torna...`,
          message: `Potrebbero non esserci disponibilità per i criteri scelti.`,
          suggestion: `Prova a modificare la ricerca o esplora nuove destinazioni.`,
        }
      }
    },
  },

  data() {
    return {
    }
  },

  computed: {
  },

  created() {
  },

  mounted() {
  },

  methods: {
  }

}
</script>

<style lang="scss" scoped>

  .not-found {
    line-height: normal;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: $grid-gutter-width * 2;

    @include media-breakpoint-up(xl) {
      margin-top: $grid-gutter-width * 3;
    }

    &__icon {
      color: var(--primary);
      margin-bottom: $grid-gutter-width / 2;
    }

    &__title {
      color: var(--primary);
      font-weight: $vb-font-weight-semibold;
      font-size: 25px;
      text-align: center;

      ::v-deep {
        strong {
          font-weight: $vb-font-weight-semibold;
          font-size: 32px;
        }
      }
    }

    &__message {
      color: $gray-900;
      font-size: $font-size-xl;
      margin-top: $grid-gutter-width / 3;
    }

    &__suggestion {
      color: var(--primary);
      margin-top: $grid-gutter-width;
      font-weight: $vb-font-weight-semibold;
    }

    &__cta {
      margin-top: $grid-gutter-20;
    }
  }

</style>